import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { L, mediaUrl } from "../lib";
import { Reveal } from "../ui";

const DOORS = [
  ["painting", "/art", "Her Paintings", "Gouache, watercolour and ink", "door-paintings", "#A3346B"],
  ["sculpture", "/art?kind=sculpture", "Her Sculpture", "Marble and alabaster", "door-sculpture", "#2F6F8A"],
  ["photographs", "/photographs", "Photographs", "Albums of a whole life", "door-photographs", "#4F8565"],
  ["life", "/life", "Her Life", "Biography, awards and exhibitions", "door-life", "#B0852A"],
  ["remembering", "/remembering", "Remembering Louise", "Stories and tributes from those who loved her", "door-remembering", "#4A4592"],
  ["video", "/in-motion", "Louise in Motion", "The family cooking show", "door-motion", "#A3346B"],
];

function Door({ img, to, title, desc, testid, big, delay, color }) {
  return (
    <Reveal delay={delay} className={big ? "sm:col-span-2 lg:col-span-6" : "lg:col-span-3"}>
      <Link to={L(to)} className="group block" data-testid={testid} style={{ "--door": color }}>
        <div className={`relative overflow-hidden bg-lou-line/40 ${big ? "aspect-[4/3]" : "aspect-[4/5]"}`}>
          {img && <img src={mediaUrl(img)} alt="" loading="lazy"
            className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]" style={{ objectPosition: testid === "door-motion" ? "38% 30%" : "50% 40%" }} />}
          <span className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 mix-blend-multiply" style={{ background: `linear-gradient(to top, ${color}55, transparent 55%)` }} />
        </div>
        <span className="block h-[3px] w-12 group-hover:w-full transition-[width] duration-500 ease-out" style={{ background: color }} />
        <div className="flex items-start justify-between gap-4 mt-4">
          <div>
            <p className={`font-lou font-light transition-colors duration-300 group-hover:text-[color:var(--door)] ${big ? "text-3xl sm:text-4xl" : "text-2xl"}`}>{title}</p>
            <p className="text-sm text-lou-soft mt-1">{desc}</p>
          </div>
          <ArrowUpRight className="shrink-0 mt-2 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform duration-300" style={{ color }} />
        </div>
      </Link>
    </Reveal>
  );
}

export default function Doorways({ doors }) {
  return (
    <section id="explore" className="max-w-7xl mx-auto px-6 lg:px-10 mt-24 sm:mt-32 scroll-mt-24" data-testid="home-doorways">
      <p className="text-xs tracking-[0.28em] uppercase text-lou-clay">Explore</p>
      <h2 className="font-lou text-3xl sm:text-4xl font-light mt-3">Her art, her life, and the people who loved her</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-12 gap-x-8 gap-y-14 mt-12">
        {DOORS.map(([k, to, title, desc, testid, color], i) => (
          <Door key={k} img={doors?.[k]} to={to} title={title} desc={desc} testid={testid} big={i < 2} delay={(i % 4) * 0.07} color={color} />
        ))}
      </div>
    </section>
  );
}
